import { Type } from "@xanadu/model";
import { DataCache } from "./data.cache";
import { DataService } from "../../service/data/data.service";
import { Injectable } from "@angular/core";

@Injectable({
    providedIn: 'root'
})
export class TypeCache extends DataCache<Type> {

    constructor(
        dataService: DataService
    ) {
        super(Type, dataService);
    }
}
